import { render, staticRenderFns } from "./TabelaDeAditivos.vue?vue&type=template&id=46c6932f&scoped=true"
import script from "./TabelaDeAditivos.vue?vue&type=script&setup=true&lang=js"
export * from "./TabelaDeAditivos.vue?vue&type=script&setup=true&lang=js"
import style0 from "./TabelaDeAditivos.vue?vue&type=style&index=0&id=46c6932f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c6932f",
  null
  
)

export default component.exports